export default __webpack_public_path__ + "static/media/qrBlog.aa18bad6.png";